import { setLoading } from "../generalActions/mainActions";
import { addItem, changeListItem, removeItem, setItems, setTableParams } from "../generalActions/listActions";
import { setForm, setItem } from "../generalActions/formActions";
import {airlineService} from "../../../jwt/_services/hotel/airlineService";

export const search = (pageIndex, pageSize, filter) => ( dispatch ) => {
    dispatch(setLoading(true))

    airlineService.search(pageIndex, pageSize, filter)
        .then(result => {
            if (!result)
                return

            dispatch(setItems(result.data))
            dispatch(setTableParams(pageSize, pageIndex, result?.total))
        })
        .finally(() => dispatch(setLoading(false)))
}

export const syncFirebase = ( data ) => ( dispatch ) => {
    dispatch(setLoading(true))

    airlineService.syncFirebase(data)
        .then(result => {
            if (!result)
                return
        })
        .finally(() => dispatch(setLoading(false)))
}

export const save = data => ( dispatch ) => {
    dispatch(setLoading(true))

    airlineService.saveItem(data)
        .then( result => {
            if(!result)
                return

            dispatch( setItem(result) )
            dispatch( setForm(false, true, true) )
            dispatch( addItem(result) )
        })
        .finally(() => dispatch(setLoading(false)))
}

export const update = (id, data) => ( dispatch ) => {
    dispatch(setLoading(true))

    airlineService.updateItem(id, data)
        .then( result => {
            if(!result)
                return

            dispatch( setItem(result) )
            dispatch( setForm(false, true, true) )
            dispatch( changeListItem(result) )
        })
        .finally(() => dispatch(setLoading(false)))
}

export const remove = (id) => ( dispatch ) => {
    dispatch(setLoading(true))

    airlineService.deleteItem(id)
        .then( result => {
            if(result?.status)
                dispatch( removeItem(id) )
        })
        .finally(() => dispatch(setLoading(false)))
}